import { render } from "./Main.vue?vue&type=template&id=30d3c06f&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "@vueform/slider/themes/default.css?vue&type=style&index=0&lang=css"
import "./Main.vue?vue&type=style&index=1&id=30d3c06f&lang=postcss&scoped=true"

import exportComponent from "/codebuild/output/src1917936756/src/quotation-sales/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30d3c06f"]])

export default __exports__